import { mantenimientos, inicio, procesos, reportes, atenciones } from './modulos';
import { urls } from './keys';
const modulos = {
    mantenimientos,
    inicio,
    procesos,
    reportes,
    atenciones,
}

export {
    modulos,
    urls,
}